module.exports = __webpack_public_path__ + "e542afe6d4ea2f00dd2b826eb599ff31.jpg";